<template>
  <section class="content">
    <div class="row">
      <div class="col-xs-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title"><i class="fa fa-building-o mr-5"></i>{{'companies_overview' | translate}}</h3>
          </div>
          <div class="box-controls">
            <div class="row">
              <div class="col-xs-12">
                <div class="collapse in" id="coll1" aria-expanded="true">
                  <div class="row">
                    <div class="col-md-3 col-sm-6" v-if="sde1Active">
                      <div class="input-group">
                        <input
                          class="form-control"
                          v-model="orgImport"
                          type="text"
                          :placeholder="'organisation_number' | translate"
                        >
                        <div class="input-group-btn">
                          <button @click="importSchuheDe" type="button" class="btn btn-primary">
                            <i class="fa fa-download mr-5"></i>
                            {{'import' | translate}}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2 col-sm-6">
                      <div class="input-group">
                        <div class="input-group-addon">
                          {{'status' | translate}}
                        </div>
                        <select class="form-control" v-model="selectedStatus" @change.prevent="paginate('','')">
                          <option class="normal" value="all">{{'all' | translate}}</option>
                          <option class="normal" value="active">{{'active' | translate}}</option>
                          <option class="normal" value="inactive">{{'inactive' | translate}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-2 col-sm-6">
                      <div class="input-group">
                        <input
                          type="text"
                          name="search"
                          class="form-control"
                          @keyup.13.prevent="paginate('','')"
                          @blur="paginate('','')"
                          v-model="selectedOrg"
                          :placeholder="'organisation_number' | translate"
                        >
                        <div class="input-group-btn">
                          <button type="submit" name="submit" class="btn"><i class="fa fa-search"></i></button>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2 col-sm-6">
                      <div class="input-group">
                        <input
                          type="text"
                          name="search"
                          class="form-control"
                          @keyup.13.prevent="paginate('','')"
                          @blur="paginate('','')"
                          v-model="selectedName"
                          :placeholder="'company_name' | translate"
                          >
                        <div class="input-group-btn">
                          <button type="submit" name="submit" class="btn"><i class="fa fa-search"></i></button>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-6 float-right">
                      <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-right">
              </div>
            </div>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-xs-12">
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead>
                    <tr>
                      <th>{{'status' | translate}}</th>
                      <th>{{'seller_status' | translate}}</th>
                      <th>{{'organisation_number' | translate}}</th>
                      <th>{{'company' | translate}}</th>
                      <th>{{'details' | translate}}</th>
                      <th>{{'erp' | translate}}</th>
                      <th>{{'edit' | translate}}</th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item, index in pagination.data">
                        <td>
                          <div class="btn-group btn-group-sm" data-toggle="btn-toggle">
                            <button
                              type="button"
                              :class="['btn btn-success btn-sm', item.is_active ? 'active' : '']"
                              @click="toggleActivation(true, item.id, index)"
                              >
                              <i class="fa fa-check"></i>
                            </button>
                            <button
                              type="button" :class="['btn btn-danger btn-sm', !item.is_active ? 'active' : '']"
                              @click="toggleActivation(false, item.id, index)"
                              >
                              <i class="fa fa-ban"></i>
                            </button>
                          </div>
                        </td>
                        <td>{{item.ranking}}</td>
                        <td>{{item.organisation_number}}</td>
                        <td>
                          <p>
                            <strong>{{item.name}}</strong><br>
                            {{item.inv_first_name}} {{item.inv_last_name}}<br>
                            {{item.inv_street}}<br>{{item.inv_postcode}} {{item.inv_city}}
                          </p>
                        </td>
                        <td>
                          <small class="text-muted">{{'contact' | translate}}:</small><br>
                          {{item.inv_email}}<br>{{item.telephone}}<br>
                          <small class="text-muted">Order-Email:</small><br>
                          {{item.qb_email}}
                        </td>
                        <td>{{item.erp_system | toUpper}}</td>
                        <td>
                          <router-link :to="'/accounting/companies/' + item.id">
                            <button class="btn btn-info btn-app no-margin">
                              <i class="fa fa-edit"></i>
                              {{'edit' | translate}}
                            </button>
                          </router-link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="box-footer">
            <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="overlay" v-show="loading">
      <img class="loading-gif" src="/static/img/blabla.svg"/>
    </div>
  </section>
</template>

<script>
  import {sde1Active} from '@/sunset-helper'

  export default {
    name: 'Companies',
    data () {
      return {
	      loading: false,
        selectedStatus: window.localStorage.getItem('companiesStatus') ? window.localStorage.getItem('companiesStatus') : 'all',
        selectedOrg: window.localStorage.getItem('companiesName') ? window.localStorage.getItem('companiesName') : '',
        selectedName: window.localStorage.getItem('companiesOrg') ? window.localStorage.getItem('companiesOrg') : '',
        count: 25,
        orgImport: '',
        companies: {},
        backup: [],
        alerts: [],
        pagination: {
          total: 0,
          per_page: 25,
          current_page: 1,
          total_pages: 0
        }
      }
    },
    computed: {
      sde1Active
    },
    methods: {
      filter () {
        let filter
        switch (this.isActive) {
          case '1':
            filter = true
            break
          case '0':
            filter = false
            break
        }
        this.companies = []
        if (this.isActive === 'all') {
          this.companies = this.backup
        } else {
          for (let x in this.backup) {
            if (this.backup[x].is_active === filter) {
              this.companies.push(this.backup[x])
            }
          }
        }
      },
      toggleActivation (value, id, index) {
        let data = {
          is_active: value
        }
        this.pagination.data[index].is_active = value
        API.put(`accounting/companies/${id}`, data)
          .then(response => {})
      },
      paginate (type, value) {
        let url = '?preflight=kek'
        if (type === 'page') {
          url += '&page='
          if (value === 'previous') {
            url += (this.pagination.current_page - 1)
          }
          if (value === 'next') {
            url += this.pagination.current_page >= this.pagination.last_page ? this.pagination.last_page : (this.pagination.current_page + 1)
          } else if (value !== 'next' && value !== 'previous') {
            url += value
          }
        }
        url += `&status=${this.selectedStatus}`
        url += `&name=${this.selectedName}`
        url += `&org=${this.selectedOrg}`
        window.localStorage.setItem('companiesStatus', this.selectedStatus)
        API.get(`accounting/companies${url}`)
          .then(response => {
            this.pagination = response.data
            window.localStorage.setItem('companiesPage', this.pagination.current_page)
          })
          .catch(error => {
            this.$parent.checkError(error)
          })
      },
      importSchuheDe () {
        if (!this.sde1Active) return
        this.loading = true
        let alert
        API.get(`accounting/import/company/${this.orgImport}`)
          .then(response => {
            if (response.status === 201) {
              this.$store.commit('pushAlert', {
                dismiss: 4,
                type: 'success',
                message: 'Import Successful',
                icon: 'icon fa fa-check',
                show: true
              })
            } else if (response.status === 204) {
              this.$store.commit('pushAlert', {
                dismiss: 4,
                type: 'warning',
                message: 'Not imported. Company Already Exists',
                icon: 'icon fa fa-warning',
                show: true
              })
            }
            this.$router.push(`/accounting/companies/${response.data.id}`)
            this.loading = false
          })
          .catch(error => {
            this.$store.commit('pushAlert', {
              dismiss: 4,
              type: 'danger',
              message: `There was an error: ${error.response.data.message}`,
              icon: 'icon fa fa-ban',
              show: true
            })
            this.loading = false
          })
      },
      getWebhook (id) {
        let alert
        API.post(`accounting/companies/${id}/webhook`)
          .then(response => {
            alert = {
              dismiss: 4,
              type: 'success',
              message: 'Webhook created successfully',
              icon: 'icon fa fa-check',
              show: true
            }
            this.$store.commit('pushALert', alert)
          })
          .catch(error => {
            alert = {
              dismiss: 4,
              type: 'warning',
              message: 'Not created. Company already has webhook',
              icon: 'icon fa fa-warning',
              show: true
            }
            this.$store.commit('pushALert', alert)
          })
      }
    },
    mounted () {
      this.$nextTick(function () {
        let url = `?page=${window.localStorage.getItem('companiesPage')}&status=${this.selectedStatus}`
        API.get(`accounting/companies${url}`)
          .then(response => {
            this.pagination = response.data
            this.backup = response.data
          })
          .catch(error => {
            this.checkError(error)
          })
      })
    }
  }
</script>
<style>
  .overlay {
    z-index: 50;
    background: rgba(33,34,40,.75);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 110%;
  }
  .overlay-text{
    position: absolute;
    top: 54%;
    left: 49%;
    margin-left: -1rem;
    margin-top: -1rem;
  }
  .overlay > .fa {
    position: absolute;
    top: 50%;
    left: 57%;
    margin-left: -1rem;
    margin-top: -1rem;
    color: currentColor;
    font-size: 2rem;
    opacity: 0.65;
  }
</style>
<style scoped>
  .loading-gif {
    display: block;
    width: 5%;
    top: 42%;
    left: 50%;
    position: fixed;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Accounting/Companies.vue